export default {
  'common.cancel': '취소',
  'common.delete': '삭제',
  'common.save': '저장',
  'common.saving': '저장 중...',
  'common.save_complete': '저장 완료!',
  'common.add': '추가',
  'common.confirm': '확인',
  'common.confirming': '확인 중...',
  'common.close': '닫기',
  'common.back': '뒤로',
  'common.next': '다음',
  'common.previous': '이전',
  'common.retry': '다시 시도',
  'common.loading': '로딩 중...',
  'common.login': '로그인',
  'common.logout': '로그아웃',
  'common.signup': '회원가입',
  'common.email': '이메일',
  'common.password': '비밀번호',
  'common.dashboard': '대시보드',
  'common.fullscreen': '전체화면',
  'common.presentation': '프레젠테이션',
  'common.copied': '복사됨!',
  'common.copy': '복사',
  'time.seconds_one': '{{count}}초',
  'time.seconds_other': '{{count}}초',
  'time.minutes_one': '{{count}}분',
  'time.minutes_other': '{{count}}분',
  'time.hours_one': '{{count}}시간',
  'time.hours_other': '{{count}}시간',
  'common.magnification': '{{count}}배',
};
